import {
  Component,
  computed,
  HostListener,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { TranslationService } from '../../services/translation.service';
import { ButtonComponent } from '../button/button.component';
import { IconComponent } from '../icon/icon.component';

// Criamos uma interface local simplificada para representar o projeto que já foi traduzido pela Home
export interface TranslatedProject {
  id: string;
  slug: string;
  image: string;
  fullImage?: string;
  icon: string;
  labels?: string[];
  name: string;
  alternativeText: string;
  description: string;
  aboutProject?: string;
  designChallengeProject?: string;
  conceptProject?: string;
  frontendChallengeProject?: string;
}

@Component({
  selector: 'app-gallery',
  standalone: true,
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
  imports: [ButtonComponent, IconComponent],
})
export class GalleryComponent {
  translate = inject(TranslationService);

  projects = input.required<TranslatedProject[]>();
  featured = input.required<TranslatedProject>();
  projectSelected = output<TranslatedProject>();
  isMobile = signal(window.innerWidth < 768);

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobile.set(window.innerWidth < 768);
  }

  selectProject(item: TranslatedProject): void {
    this.projectSelected.emit(item);
  }

  truncatedDescription = computed(() => {
    const text = this.featured()?.description;
    if (!text) return '';

    const limit = this.isMobile() ? 55 : 180;
    return text.length > limit ? text.substring(0, limit) + '...' : text;
  });
}
